import React from 'react';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  Checkbox,
} from '@mui/material';
import classNames from 'classnames';
import c from '../shared.Module.scss';
import Text from '../../Shared/Text';
import IconButton from '@mui/material/IconButton';
import SwitchLeftIcon from '@mui/icons-material/SwitchLeft';

const CustomTable = ({
  columns = [],
  onClick,
  showPagination = true,
  showSortIcon = true,
  minWidth = true,
  maxHeight,
  pageNo = 0,
  setTablePageNo = null,
  rowsPerPage = 10,
  setRowsPerPage = null,
  noOuterPadding = false,
  handleChangePage,
  handleRowsChange,
  totalCount,
  isTotalCount,
  checkedAll,
  setCheckedAll,
  handleSelectAll,
  isCheckbox,
  ...props
}) => {
  const handleShowPagination = () => {
    if (showPagination)
      if (isTotalCount && totalCount == 0) {
        return false;
      }
    return true;
  };

  return (
    <>
      <TableContainer
        className={classNames(c.tableContainer, !noOuterPadding && 'px-3')}
        sx={{ maxHeight: maxHeight }}
      >
        <Table stickyHeader aria-label="stickyTable" size="small">
          <TableHead>
            <TableRow>
              {isCheckbox && (
                <TableCell key="checkbox" padding="checkbox" className={c.tableHeading}>
                  <Checkbox
                    color="primary"
                    checked={checkedAll}
                    onChange={() => handleSelectAll()}
                  />
                </TableCell>
              )}
              {columns.map((column) => (
                <TableCell key={column.id} className={c.tableHeading}>
                  <Text
                    textType="t1"
                    classToOverride={classNames('fw-bold', minWidth && c.tableWidth)}
                  >
                    {column?.label}
                    {showSortIcon && (
                      <IconButton
                        className="ms-1"
                        onClick={() => Boolean(onClick) && onClick(column?.id)}
                      >
                        <SwitchLeftIcon className={c.tableSortIcon} />
                      </IconButton>
                    )}
                  </Text>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>{props?.children}</TableBody>
        </Table>
      </TableContainer>
      {handleShowPagination() && (
        <TablePagination
          component="div"
          className={c.tablePagination}
          count={isTotalCount ? totalCount : -1}
          rowsPerPageOptions={[10, 25, 100]}
          rowsPerPage={rowsPerPage}
          page={pageNo}
          onPageChange={(e, page) => {
            console.log('pageNo', page);
            if (setTablePageNo) setTablePageNo(page);
            else {
              if (handleChangePage) {
                handleChangePage(page);
              }
            }
          }}
          onRowsPerPageChange={(e) => {
            console.log('rows per page changed', e?.target?.value);
            if (setRowsPerPage) setRowsPerPage(e?.target?.value);
            else {
              if (handleRowsChange) {
                handleRowsChange(e);
              }
            }
          }}
        />
      )}
    </>
  );
};

export default CustomTable;
